import FilterPostType from '@/components/pages/myprofile/filters/FilterPostType';
import FilterPromotionType from '@/components/pages/myprofile/filters/FilterPromotionType';
import SelectLabels from '@/components/pages/myprofile/filters/SelectLabels';
import { BaseXTab, type BaseXTabProps } from '@/components/pages/myprofile/tabs/BaseXTab';

type PostsXTabProps = Omit<
    BaseXTabProps,
    'initialParams' | 'renderFilters' | 'exportType' | 'hasFilter'
>;

const PostsXTab = (props: PostsXTabProps) => (
    <BaseXTab
        {...props}
        renderFilters={(resetFilters, setResetFilters, setRequestParams) => (
            <>
                <FilterPostType
                    resetFilters={resetFilters}
                    stopResetFilters={() => setResetFilters(false)}
                    setRequestParams={setRequestParams}
                />
                <FilterPromotionType
                    resetFilters={resetFilters}
                    stopResetFilters={() => setResetFilters(false)}
                    setRequestParams={setRequestParams}
                />
                {/* @ts-expect-error - SelectLabels is not typed */}
                <SelectLabels
                    resetFilters={resetFilters}
                    stopResetFilters={() => setResetFilters(false)}
                    setRequestParams={setRequestParams}
                />
            </>
        )}
    />
);

export default PostsXTab;
